import { getAuthServiceUrl, getDiceServiceUrl } from "@/constants";
import { useUserDiceDataStore } from "@/hooks/useUserDiceDataStore";
import type { DiceData } from "@/types";
import { getJwt } from "@dndbeyond/auth/browserAuth";
import { useEffect } from "react";

export const useUserDiceData = (
  nodeEnv?: string,
  env?: string,
  userId?: number,
) => {
  const { setUserDiceData } = useUserDiceDataStore();

  useEffect(() => {
    if (!userId || !nodeEnv || !env) return;

    (async () => {
      const stt = await getJwt(new URL(getAuthServiceUrl(nodeEnv, env)), {
        credentials: "include",
        useCache: false,
        parseToken: false,
      });
      const response = await fetch(
        `${getDiceServiceUrl(nodeEnv, env)}/diceuserconfig/v1/get`,
        {
          headers: {
            Authorization: `Bearer ${stt}`,
          },
        },
      );

      if (response.ok) {
        const { data } = (await response.json()) as { data: DiceData };

        setUserDiceData(userId, data);
      }
    })();
  }, [env, nodeEnv, setUserDiceData, userId]);
};
